import React, { useEffect, useState, useRef } from 'react';

export const useClickOutside = (initialState, ignoreElementRef = null) => {
    const [ open, setOpen ] = useState(initialState);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                if (ignoreElementRef && ignoreElementRef.current && ignoreElementRef.current.contains(e.target)) {
                    return;
                }
                setOpen(false);
            }            
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    },[ignoreElementRef]);

    return [ref, open, setOpen];
};